import { useState } from 'react';
import { rm } from 'utils';
import { reloadCart } from 'components/Cart/actions';
import batchAction from 'store/batching';
import { AddressInfo } from 'models/AddressInfo';
import { CheckoutModal } from 'views/CheckoutPage/checkoutModal';
import { styled } from 'styled-components';
import { LabeledInput } from 'components/Shared/Form/LabeledInput/themes/BGH';
import { Button } from 'components/Button';
import { setAddressDetails } from 'views/CheckoutPage/actions';
import { useDispatch } from 'react-redux';
import { TooLongNameModalProps } from 'views/CheckoutPage/ContactInfo/TooLongNameModal/index';

const ContentWrapper = styled('div')({
  display: 'grid',
  gap: '2rem'
});

const InputWrapper = styled('div')({
  gap: '1rem 2rem',
  display: 'grid'
});

const ProgressSpan = styled('span')({
  justifySelf: 'end',
  lineHeight: '1'
});

export const TooLongNameCompanyModal = ({ address, maxNameLength }: TooLongNameModalProps) => {
  const reduxDispatch = useDispatch();
  const [companyName, setCompanyName] = useState(address.lastName); // Companies only have a last name

  const handleSubmit = () => {
    const newAddress: AddressInfo = {
      ...address,
      isTooLongName: false,
      hasNameOverride: true,
      lastName: companyName
    };

    reduxDispatch(batchAction(setAddressDetails(newAddress), reloadCart()));
  };

  const combinedLength = companyName?.trim().length ?? 0;

  return (
    <CheckoutModal show={true}>
      <h2>{rm('checkout_too_long_name_header')}</h2>
      <ContentWrapper>
        <span>{rm('checkout_too_long_name_body_company', maxNameLength)}</span>

        <InputWrapper>
          <LabeledInput
            id="companyName"
            label={rm('Checkout_company_name')}
            type="text"
            value={companyName}
            valid={combinedLength <= maxNameLength}
            aria-invalid={combinedLength > maxNameLength}
            onChange={e => setCompanyName(e.target.value)}
          />
          <ProgressSpan>
            ({combinedLength} / {maxNameLength})
          </ProgressSpan>
        </InputWrapper>

        <Button
          appearance="secondary"
          onClick={handleSubmit}
          disabled={combinedLength > maxNameLength}
        >
          {rm('checkout_modal_confirm')}
        </Button>
      </ContentWrapper>
    </CheckoutModal>
  );
};
